import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import PageTitle from 'components/PageTitle/PageTitle';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { FEATURE_CATEGORY, FEATURE_TYPE, FEATURE_UNIT } from 'data/consts';

interface FeatureFormProps {
    feature: any;
    onSubmit: (data: any) => void;
}

export const FeatureForm = ({ feature, onSubmit }: FeatureFormProps) => {
    const methods = useForm({
        defaultValues: {
            code: feature?.code || '',
            name: feature?.name || '',
            category: feature?.category || '',
            type: feature?.type || '',
            unit: feature?.unit || '',
        },
    });


    return (
        <div>
            <PageTitle>{feature?.id ? 'Редактировать функционал' : 'Добавить функционал'}</PageTitle>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)} className="flex flex-col gap-4 mt-6">
                    <TextField label="Системное название" {...methods.register('code')} fullWidth />
                    <TextField label="Название" {...methods.register('name')} fullWidth />

                    <Controller control={methods.control} name="category" render={({ field }) => {
                        return <FormControl>
                            <InputLabel id="category-label">Категория</InputLabel>
                            <Select label="Категория" {...field} fullWidth>
                                {Object.entries(FEATURE_CATEGORY).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>
                                        {value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    }} />
                    <Controller control={methods.control} name="type" render={({ field }) => {
                        return <FormControl>
                            <InputLabel id="type-label">Тип</InputLabel>
                            <Select label="Тип" {...field} fullWidth>
                                {Object.entries(FEATURE_TYPE).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>
                                        {value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    }} />
                    <Controller control={methods.control} name="unit" render={({ field }) => {
                        return <FormControl>
                            <InputLabel id="unit-label">Единица измерения</InputLabel>
                            <Select label="Единица измерения" {...field} fullWidth>
                                {Object.entries(FEATURE_UNIT).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>
                                        {value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    }} />


                    <Button type="submit" variant="contained" color="primary">Сохранить</Button>
                    <pre>{JSON.stringify(methods.watch(), null, 2)}</pre>
                </form>
            </FormProvider>
        </div>
    )
}
